export default {"src":"/_next/static/media/active_facilities.11146eb9.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};